import React from 'react'

import { H2 } from '@frame/ui-primitives/h2'
import { P } from '@frame/ui-primitives/p'

import { LearnMore } from './learn-more-content'

type Props = {
  verifierName: string
  showLearnMore: boolean
}

export function SomeTasksVerifiedContent({ verifierName, showLearnMore }: Props) {
  return (
    <>
      <H2 className="mb-3 mt-5 text-center">Verification in progress</H2>
      <P>
        Thanks for providing your information. If you could not complete a verification, we'll pass the info to{' '}
        {verifierName}. Contact {verifierName} if you have questions.
      </P>
      {showLearnMore && (
        <P className="mt-3">
          <LearnMore />
        </P>
      )}
    </>
  )
}
